<template>
    <info-screen
            :title="title"
            :text="text"
            :action="nextScreen"
            :button-text="$ml.get('sendCodeEnterCode')"
            :headerImg="callEnabled ? 12 : 11"
    >
        <a class="link" @click="back">{{changeText}}</a>
    </info-screen>
</template>

<script>
    import InfoScreen from "../../components/layout/info-screen";
    import Profile from '../../helpers/profile'

    export default {
        name: "sendCodePage",
        components: {InfoScreen},
        data() {
            return {
                changeText: '',
                title: '',
                text: '',
                isSecondOtp: !!Profile.secondOTP.username,
                isThirdOtp: !!Profile.thirdOTP.username,
            }
        },
        created() {
            let isMobile = window.innerWidth < 600;
            if (!isMobile) {
                if (Profile.process === 'accessRecovery') {
                    if (this.isThirdOtp)
                        this.$router.replace('/accessRecovery/enterThirdCode');
                    else if (this.isSecondOtp)
                        this.$router.replace('/accessRecovery/enterSecondCode');
                    else
                        this.$router.replace('/accessRecovery/enterCode');
                } else
                    this.$router.replace({ name: 'LoginEnterCode'});
            }
        },
        computed: {
            callEnabled: function () {
                return Profile.otptype === 'sms';
            },
        },
        mounted: function () {
            let username = Profile.process === "accessRecovery" ? Profile.recoveryContacts[Profile.recoveryMethod] : Profile.username;
            if (this.isThirdOtp) {
                username = Profile.thirdOTP.username;
                this.title = this.$ml.get('sendCodeTitleMail');
                this.changeText = this.$ml.get('sendCodeChangeMail');
                this.text = this.$ml.get('sendCodeTextMail')+'<strong>'+username.trim()+'</strong>'
            } else if (this.isSecondOtp) {
                username = Profile.secondOTP.username;
                if (Profile.secondOTP.otptype === 'sms') {
                    this.title = this.$ml.get('sendCodeTitlePhone');
                    this.changeText = this.$ml.get('sendCodeChangePhone');
                    this.text = this.$ml.get('sendCodeTextPhone')+'<strong>'+username.trim()+'</strong>'
                } else {
                    this.title = this.$ml.get('sendCodeTitleMail');
                    this.changeText = this.$ml.get('sendCodeChangeMail');
                    this.text = this.$ml.get('sendCodeTextMail')+'<strong>'+username.trim()+'</strong>'
                }
            } else if (Profile.otptype === 'sms') {
                this.title = this.$ml.get('sendCodeTitlePhone');
                this.changeText = this.$ml.get('sendCodeChangePhone');
                this.text = this.$ml.get('sendCodeTextPhone')+'<b>'+username.trim()+'</b>'
            } else {
                this.title = this.$ml.get('sendCodeTitleMail');
                this.changeText = this.$ml.get('sendCodeChangeMail');
                this.text = this.$ml.get('sendCodeTextMail')+' <b>'+username.trim()+'</b>'
            }
        },

        methods: {
            nextScreen: function () {
                this.$router.push({name: 'LoginEnterCode'});
            },

            back: function () {
                this.$router.back();
            }
        }

    }
</script>

<style lang="scss" scoped>

</style>